import Navigation from '@pelckmans/elementis/components/navigation';
import MethodsIcon from '@pelckmans/elementis/icons/methods';
import UserIcon from '@pelckmans/elementis/icons/user';
import UsersIcon from '@pelckmans/elementis/icons/users';
import Badge from '@pelckmans/elementis/components/badge';
import { useBreakpoint } from '@pelckmans/elementis/contexts/BreakpointsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import IdentityContext from '../../../contexts/IdentityContext';
import { useRoutes } from '../../../hooks/useRoutes';
import InvitationContext from '../../../contexts/InvitationContext';
import PelckmansLogo from '../../sidebar/components/PelckmansLogo';
import User from '../../sidebar/components/User';

function ApplicationNavigation() {
  const { buildAbsolutePath } = useRoutes();
  const { t } = useTranslation();

  const { identity } = useContext(IdentityContext);
  const { pendingInvitations } = useContext(InvitationContext);

  const breakpoint = useBreakpoint();

  const isMobile = breakpoint === 'mobile';

  return (
    <header className="application-navigation">
      <div className="content">
        {isMobile && <PelckmansLogo />}
        <Navigation className="middle-navigation">
          <Navigation.List orientation="horizontal">
            <Navigation.Item
              icon={<MethodsIcon />}
              to={buildAbsolutePath(['MY_METHODS'])}
              iconOnly={isMobile}
              end={false}
            >
              {t('APP_NAV.TOP_NAV.MY_METHODS')}
            </Navigation.Item>

            {identity.isTeacherAlike ? (
              <Navigation.Item
                icon={<UsersIcon />}
                to={buildAbsolutePath(['MY_GROUPS'])}
                iconOnly={isMobile}
                end={false}
              >
                {t('APP_NAV.TOP_NAV.MY_GROUPS')}
              </Navigation.Item>
            ) : (
              <Navigation.Item
                badge={pendingInvitations.length > 0 ? <Badge>{pendingInvitations.length}</Badge> : undefined}
                icon={<UsersIcon />}
                to={buildAbsolutePath(['MY_TEACHERS'])}
                iconOnly={isMobile}
                end={false}
              >
                {t('APP_NAV.TOP_NAV.MY_TEACHERS')}
              </Navigation.Item>
            )}

            <Navigation.Item icon={<UserIcon />} to={buildAbsolutePath(['MY_PROFILE'])} iconOnly={isMobile} end={false}>
              {t('APP_NAV.TOP_NAV.MY_PROFILE')}
            </Navigation.Item>
          </Navigation.List>
        </Navigation>
        {isMobile && <User />}
      </div>
    </header>
  );
}

export default ApplicationNavigation;
